import { Button } from '@mui/material';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/system';
import Image from 'next/image';
import { useRouter } from 'next/router';
import * as React from 'react';
import { API } from '_helpers';
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';

const FAQ: React.FC<IProps<IFaq>> = ({ data }) => {
  const router = useRouter();
  const handleClick = (href: string) => {
    router.push(href);
  };
  return (
    <Box
      sx={{
        py: 12,
        bgcolor: (theme) =>
          theme.palette.mode === 'dark'
            ? `${alpha(theme.palette.action.active, 0.02)}`
            : theme.palette.grey.A200,
      }}
    >
      <Container>
        <Stack spacing={2} sx={{ px: { xs: 0, md: 12, lg: 20 } }}>
          <Typography
            component="h2"
            color="text.primary"
            variant="h2"
            textAlign="center"
            gutterBottom
          >
            {data.title}
          </Typography>
          <Typography color="text.secondary" textAlign="center" gutterBottom>
            {data.description}
          </Typography>
        </Stack>
        <Grid container spacing={4} sx={{ py: 4 }}>
          <Grid item xs={12} md={6}>
            <Stack spacing={4} sx={{ py: 4 }}>
              {data.list.map((el, i) => (
                <Stack spacing={2} key={el._id}>
                  <Typography component="h3" variant="h2">
                    {el.question}
                  </Typography>
                  <Typography color="text.secondary">{el.answer}</Typography>
                </Stack>
              ))}
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Stack
              alignItems="center"
              justifyContent="center"
              sx={{
                width: '80%',
                height: '100%',
                m: 'auto',
              }}
            >
              <Image
                alt={data.media.alternativeText}
                src={API + data.media.url}
                width={data.media.width}
                height={data.media.height}
                quality={100}
              />
            </Stack>
          </Grid>
        </Grid>

        <Button
          sx={{
            my: 2,
            background: (theme) => alpha(theme.palette.primary.main, 0.1),
          }}
          onClick={() => handleClick(`/faq`)}
          color="primary"
          disableElevation
          component="a"
          endIcon={<ArrowRightAltIcon />}
        >
          Go to Frequency Asked Questions
        </Button>
      </Container>
    </Box>
  );
};

export default FAQ;
